import { useCallback } from 'react'
import { usePermissions } from '~/entities/viewer'
import { MassMailing } from '~/shared/api/massMailing'
import {
  driverStatusVariant,
  massMailingStatusLabels,
  OptionEnum,
} from '~/shared/config/constants'
import { DriverStatus } from '~/shared/config/enums'
import { AsyncGrid, FetchRowsFn } from '~/shared/ui/AsyncGrid'
import { Button } from '~/shared/ui/Buttons'
import { PlusIcon } from '~/shared/ui/Icons'
import { columns } from './columns'
import { filters } from './filters'
import { GridRow } from './types'

export const ListMassMailing = () => {
  const { canMassMailingUpdate } = usePermissions()

  const fetchRows = useCallback<FetchRowsFn<GridRow>>(
    async (page, pageSize, filters = [], sort) => {
      let builder = MassMailing.limit(pageSize)

      sort
        ? (builder = builder.orderBy(sort))
        : (builder = builder.orderBy('-createdAt'))

      filters.forEach(({ key, value }) => {
        if (key === 'regions') {
          builder = builder.option('filter[regions][id]', value)
        } else {
          builder = builder.where(key, value)
        }
      })

      const response = await builder.get(page)

      const data = response.getData()
      const rows = data.map((massMailing: MassMailing) => {
        const status = massMailing.getStatus()
        const options = massMailing.getUserStatusesOptions()
        const userStatusItems = (options || []).map(
          (option: OptionEnum<DriverStatus>) => ({
            label: option.label,
            color: driverStatusVariant[option.id],
          }),
        )

        return {
          ...massMailing.getAttributes(),
          id: massMailing.getApiId() as UniqueId,
          userStatus: userStatusItems,
          status: {
            label:
              massMailingStatusLabels[
                status as keyof typeof massMailingStatusLabels
              ],
            color: massMailing.getStatusVariant(status),
          },
        }
      })

      /*
       * Coloquent не дает метода, чтобы получить объект meta,
       * поэтому в данном случае получаем оригинальный ответ и достаем мету из него
       * TODO: Реализовать лучший способ получения метаданных
       * */
      const httpClientResponse = response.getHttpClientResponse()
      const axiosResponse = httpClientResponse?.getUnderlying()
      const total = axiosResponse?.data?.meta?.page?.total || 0

      return {
        rows,
        total,
      }
    },
    [],
  )

  return (
    <AsyncGrid<GridRow>
      gridKey='mass-mailings'
      columns={columns}
      smallTitle='Уведомления'
      fetchRows={fetchRows}
      filters={filters}
      headerExtra={
        <Button
          startDecorator={<PlusIcon />}
          to='new'
          show={canMassMailingUpdate}
        >
          Добавить
        </Button>
      }
    />
  )
}
